import { useEffect } from "react";

import { useCurrentStateAndParams, useTransitionHook } from "@uirouter/react";

import { TOPICS_WRAPPER_ID } from "./constants";
import { ModalFlow } from "./Modal/types";

export const useTopicsParamsControl = () => {
    const {
        params: { isAddTopicModalOpened, shouldScrollToTopics },
    } = useCurrentStateAndParams<{
        isAddTopicModalOpened?: boolean;
        shouldScrollToTopics?: boolean;
    }>();

    useEffect(() => {
        if (shouldScrollToTopics) {
            document.getElementById(TOPICS_WRAPPER_ID)?.scrollIntoView({ behavior: "smooth" });
        }
    }, [shouldScrollToTopics]);

    // cleanup of the URL query params used for control
    useTransitionHook(
        "onStart",
        {
            from: (_, transition) => {
                const fromParams = transition.params();

                return !!(fromParams.isAddTopicModalOpened || fromParams.shouldScrollToTopics);
            },
        },
        (transition) =>
            transition.targetState().withParams({ isAddTopicModalOpened: undefined, shouldScrollToTopics: undefined }),
        { invokeLimit: 1 },
    );

    return {
        initialModalData: isAddTopicModalOpened
            ? {
                  modalFlow: ModalFlow.Add,
              }
            : undefined,
    };
};
